import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Badge from "../../../components/Badge";
import Button from "../../../components/Button";
import { Schema } from "../../../api/types";
import useDeleteSchema from "../../../api/useDeleteSchema";
import { typedSxMap } from "../../../utils/typedSxMap";

type DeleteSchemaModalProps = {
  workspaceId: string;
  schema: Schema | null;
  onSuccess: () => void;
};

const styles = typedSxMap({
  actionButtons: {
    display: "flex",
    gap: "var(--m)",
    justifyContent: "flex-end",
    marginTop: "var(--m)",
  },
});

export default function DeleteSchemaForm({ workspaceId, schema, onSuccess }: DeleteSchemaModalProps) {
  const { mutate, isLoading, isSuccess } = useDeleteSchema(workspaceId, schema?.id);

  const onDeleteConfirm = () => {
    mutate(schema?.id);
    onSuccess();
  };

  useEffect(() => {
    if (isSuccess && onSuccess) onSuccess();
  }, [isSuccess]);

  return (
    <Box>
      <p>
        Are you sure you want to delete <Badge variants={["deep"]}>{schema?.name}</Badge>? Any applications using this schema will no longer work.
        This action cannot be undone.
      </p>
      <fieldset disabled={isLoading}>
        <Box sx={styles.actionButtons}>
          <Button type="button" onClick={onSuccess}>
            Cancel
          </Button>
          <Button variants={["warning"]} type="button" onClick={onDeleteConfirm}>
            Delete
          </Button>
        </Box>
      </fieldset>
    </Box>
  );
}
